
export class User {
    id_usuario: number;
    username: string;
    firstName: string;
    lastName: string;
    token: string;
    token_pass : any[];
    razonSocial: string;
    urlLogo: string;
    short_name?: string;
    datos_personales?: any;
    ind_estado? : number;
    ind_instancia? : number;
}



// WEBPACK FOOTER //
// ./src/app/core/services/auth/user.ts